import { render, staticRenderFns } from "./ChapterCard.vue?vue&type=template&id=4027b130&scoped=true"
import script from "./ChapterCard.vue?vue&type=script&lang=js"
export * from "./ChapterCard.vue?vue&type=script&lang=js"
import style0 from "./ChapterCard.vue?vue&type=style&index=0&id=4027b130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4027b130",
  null
  
)

export default component.exports